<template>
    <div class="topnav page-topnav" style="padding: 0 12px; max-height: none; overflow-y: visible">
        <div class="container-fluid">
            <nav class="navbar navbar-light navbar-expand topnav-menu">
                <div class="navbar-collapse align-items-center justify-content-between">
                    <ul v-if="(user_groups.length > 0)" class="navbar-nav">
                        <li class="nav-item">
                            <h6 class="contact-links pr-2">
                                <div
                                    class="fa-stack font-size-10"
                                    v-b-tooltip:hover
                                    :title="$root.text('user group', null, true)"
                                >
                                    <i
                                        class="fa-solid fa-stack-1x fa-circle text-inv-secondary"
                                        style="margin: 0; font-size: 26px; left: -4px; top: -2px"
                                    ></i>
                                    <i class="fal fa-user-group fa-stack-1x font-size-13 text-secondary"></i>
                                </div>
                            </h6>
                        </li>
                        <li class="nav-item" style="min-width: 200px; padding-top: 8px">
                            <searchable-option-list
                                :key="'home-panels-user-group-' + ($root.current_language || 0)"
                                v-model="user_group"
                                :value="user_group"
                                :options="getUserGroupOptions()"
                                :field_id="'home-panel-user-group'"
                            ></searchable-option-list>
                        </li>
                    </ul>
                    <ul v-else class="navbar-nav">
                        <li class="nav-item">
                            <h6 class="contact-links">
                                &nbsp;
                            </h6>
                        </li>
                    </ul>
                    <ul class="navbar-nav">
                        <li class="nav-item" style="height: 36.5px">
                            <div style="position: absolute; height: 36.5px; right: 0">
                                <button type="button" class="btn btn-secondary mr-2" @click="resetAddHomePanelForm()">
                                    <i class="far fa-plus mr-1"></i> {{ $root.text('Add panel', null, true) }}
                                </button>
                                <button type="button" class="btn btn-primary" @click="finishEditing()">
                                    <i class="far fa-check mr-1"></i> {{ $root.text('Finish editing', null, true) }}
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                user_groups: [],
                user_group: -1
            }
        },
        mounted () {
            this.getUserGroups();
        },
        watch: {
            user_group: function (val) {
                if (!val) {
                    var vm = this;
                    setTimeout(function () {
                        vm.user_group = -1;
                    }, 200);

                    return null;
                }
                this.$root.edit_homepage_user_group = val;
                const appComponent = this.$root.findComponent(this.$root, 'main-app');
                const component = this.$root.findComponent(appComponent, 'home');
                component.getPanels();
            }
        },
        methods: {
            getUserGroups: function () {
                /**
                 * Send request to API
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/user-groups/!private';
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.user_groups = response.data.user_groups;
                })
                .catch(function (error) {
                    // Do anything?
                });
            },
            getUserGroupOptions: function () {
                let options = [{
                    id: -1,
                    name: this.$root.text('None', null, true)
                }];
                if (this.user_groups) {
                    this.user_groups.forEach((item) => {
                        options.push({
                            id: item.id,
                            name: item.name
                        });
                    });
                }

                return options;
            },
            userGroupName: function () {
                if ((this.user_group < 1) || (this.user_groups.length < 1)) {
                    return this.$root.text('Select a user group', null, true);
                }
                let itemIndex = -1;
                this.user_groups.forEach((item, index) => {
                    if (item.id == this.user_group) {
                        itemIndex = index;
                    }
                });
                if (itemIndex > -1) {
                    return this.user_groups[itemIndex].name;
                }

                return this.$root.text('None', null, true);
            },
            finishEditing: function () {
                this.$root.editing_homepage = false;
                this.$root.edit_homepage_user_group = -1;
                const appComponent = this.$root.findComponent(this.$root, 'main-app');
                const component = this.$root.findComponent(appComponent, 'home');
                component.getPanels();
            },
            resetAddHomePanelForm: function () {
                $('#home-panel-edit-form-modal').modal('show');
                const appComponent = this.$root.findComponent(this.$root, 'main-app');
                if (appComponent) {
                    const homeComponent = this.$root.findComponent(appComponent, 'home');
                    const component = this.$root.findComponent(homeComponent, 'home-panel-edit-form');
                    component.resetForm();
                }
            }
        }
    }
</script>
